import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const collectionList = (formData) => {
    return axiosInstance.post(`api/lab-user/shift-list`, formData);
}

export const collectionListDetail = (id) => {
    return axiosInstance.post(`api/lab-user/shift-detail/${id}`, {});
}